<template>
    <b-card header="Sign up">
        <b-form @submit.prevent="onSubmit" >
            <b-form-group id="name-label" label="Name:" label-for="name">
                <b-form-input id="name" v-model="name" type="text" required placeholder="Enter name"></b-form-input>
            </b-form-group>
            <b-form-group id="email-label" label="Email address:" label-for="email">
                <b-form-input id="email" v-model="login" type="email" required placeholder="Enter email"></b-form-input>
            </b-form-group>
            <b-form-group id="password-label" label="Password:" label-for="password">
                <b-form-input id="password" v-model="password" type="password" required placeholder="Enter password"></b-form-input>
            </b-form-group>
            <b-button type="submit" variant="primary">Sign up</b-button>
        </b-form>
    </b-card>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  data () {
    return {
      login: '',
      password: '',
      name: '',
    }
  },
  computed: {
    ...mapGetters(['user']),
    nextRoute () {
      return this.$route.query.redirect || '/'
    }
  },
  watch: {
    user (auth) {
      if(!!auth){
        this.$router.replace(this.nextRoute)
      }
    }
  },
  methods: {
    async onSubmit () {
      let res = await this.$auth.register(this.login, this.password, this.name)
    }
  }
}
</script>